var map = {
	"./dashboard/routes.ts": 6773,
	"./historico-escolar/emitir-historico-escolar/routes.ts": 9411,
	"./historico-escolar/manutencao-de-amparo-legal-para-historico-escolar/routes.ts": 6206,
	"./historico-escolar/permitir-inserir-historico/routes.ts": 2464,
	"./historico-escolar/permitir-vincular-historico/routes.ts": 8718,
	"./historico-escolar/relatorio-de-alunos-com-pendencias-no-historico/routes.ts": 6186,
	"./historico-escolar/relatorio-de-alunos-concludentes/routes.ts": 6506,
	"./historico-escolar/relatorios-de-aluno-em-progressao-parcial/routes.ts": 2344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3019;